window.CylindoAB = {
  variant: null,

  // Called by WebTrends Optimize — pass 'hide' to suppress the button.
  setVariant: function (v) {
    this.variant = v;
    (window.__cylindo360Instances || []).forEach(function (instance) {
      instance._updateButtonVisibility();
    });
  },

  isHideVariant: function () {
    return this.variant === 'hide';
  },
};
